import { render, staticRenderFns } from "./ComponentDialog.vue?vue&type=template&id=40dd234c"
import script from "./ComponentDialog.vue?vue&type=script&lang=js"
export * from "./ComponentDialog.vue?vue&type=script&lang=js"
import style0 from "./ComponentDialog.vue?vue&type=style&index=0&id=40dd234c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports